import { axios } from "@/lib/axios";

export type BetType = 1 | 2;

export interface GuessCommentsWithoutTitleItem {
    id: number;
    userId: string;
    username: string;
    userAvatar: string;
    createTime: string;
    content: string;
    comments: number;
    likes: number;
    likeTag: boolean;
    highlight?: boolean;
    betType?: BetType;
    categoryName?: string;
    groupTitle?: string;
}

export interface GuessCommentsIndexItem extends GuessCommentsWithoutTitleItem {
    eventNo: string;
    eventTitle: string;
    guessNo: string;
    guessTitle: string;
    children?: GuessCommentsWithoutTitleItem[];
}

export interface ResultVOListGuessCommentsIndexItem {
    code: number;
    msg: string;
    total: number;
    page: number;
    data: GuessCommentsIndexItem[];
    traceId: string;
}

export interface GuessCommentsPageItem extends GuessCommentsWithoutTitleItem {
    eventNo: string;
    eventTitle: string;
    guessNo: string;
    guessTitle: string;
}

export interface ResultVOListGuessCommentsPageItem {
    code: number;
    msg: string;
    total: number;
    page: number;
    data: GuessCommentsPageItem[];
    traceId: string;
}

export interface UserBoughtEventGuessItem {
    guessNo: string;
    betType: BetType;
    guessTitle?: string;
    groupTitle?: string;
    nowChancePercentage?: number;
    userChancePercentage?: number;
}

export interface ResultVOListUserBoughtEventGuessItem {
    code: number;
    msg: string;
    total: number;
    page: number;
    data: UserBoughtEventGuessItem[];
    traceId: string;
}

export interface ResultVOBoolean {
    code: number;
    msg: string;
    total: number;
    page: number;
    data: boolean;
    traceId: string;
}

export interface IndexCommentsRequest {
    eventNo: string;
    size?: number;
    childSize?: number;
    commentId?: number;
}

export interface PageCommentsRequest {
    eventNo: string;
    offsetId?: number;
    rootId?: number;
    size?: number;
}

export interface CommentGuessRequest {
    eventNo: string;
    parentId?: number;
    guessNo?: string;
    betType?: BetType;
    content: string;
}

export interface IdRequest {
    id: number;
}

// Page request for pagination
export interface PageRequest {
    offsetId?: number;
    size?: number;
    userId?: number | string;
}

// My comments page item
export interface MyCommentsPageItem {
    id: number;
    createTime: string;
    eventNo: string;
    eventTitle: string;
    guessNo: string;
    guessTitle: string;
    betType: BetType;
    betTypeDesc?: string;
    userChancePercentage: number;
    nowChancePercentage: number;
    content: string;
    comments: number;
    likes: number;
    likeTag: boolean;
    categoryName?: string;
    groupTitle?: string;
}

// My reply page item
export interface MyReplyPageItem extends MyCommentsPageItem {
    reply: GuessCommentsWithoutTitleItem;
}

// My like page item
export interface MyLikePageItem {
    id: number;
    createTime: string;
    eventNo: string;
    eventTitle: string;
    guessNo: string;
    guessTitle: string;
    betType: BetType;
    betTypeDesc?: string;
    userChancePercentage: number;
    nowChancePercentage: number;
    content: string;
    comments: number;
    likes: number;
    username?: string;
    userAvatar?: string;
    userId?: string;
    categoryName?: string;
    groupTitle?: string;
}

// Response types
export interface ResultVOListMyCommentsPageItem {
    code: number;
    msg: string;
    total: number;
    page: number;
    data: MyCommentsPageItem[];
    traceId: string;
}

export interface ResultVOListMyReplyPageItem {
    code: number;
    msg: string;
    total: number;
    page: number;
    data: MyReplyPageItem[];
    traceId: string;
}

export interface ResultVOListMyLikePageItem {
    code: number;
    msg: string;
    total: number;
    page: number;
    data: MyLikePageItem[];
    traceId: string;
}

export function apiGetGuessCommentsIndex( params: IndexCommentsRequest ) {
    return axios.post( "/api/front/user/comments/guess/index", params );
}

export function apiGetGuessCommentsPage( params: PageCommentsRequest ) {
    return axios.post( "/api/front/user/comments/guess/page", params );
}

export function apiListUserBoughtGuessOptions( params: { eventNo: string } ) {
    return axios.post( "/api/front/user/comments/guess/list/user/bought", params );
}

export function apiLikeGuessComment( params: IdRequest ) {
    return axios.post( "/api/front/user/comments/guess/like", params );
}

export function apiUnlikeGuessComment( params: IdRequest ) {
    return axios.post( "/api/front/user/comments/guess/unlike", params );
}

export function apiCommentGuess( params: CommentGuessRequest ) {
    return axios.post( "/api/front/user/comments/guess/comment", params );
}

// Profile comments API
export function apiGetMyComments( params: PageRequest ) {
    return axios.post( "/api/front/user/comments/my", params );
}

export function apiGetMyReplies( params: PageRequest ) {
    return axios.post( "/api/front/user/comments/my/reply", params );
}

export function apiGetMyLikes( params: PageRequest ) {
    return axios.post( "/api/front/user/comments/my/likes", params );
}

export function apiGetGuessHoldingList( params: { guessNo: string } ) {
    return axios.post( "/api/front/guest/guess-holding-list", params );
}

export function apiGetEventTradeRecordList(
    params: { pageNum: number; pageSize: number; eventNo: string; guessNo?: string; minAmount?: number },
) {
    return axios.post( "/api/front/guest/event-trade-record-list", params );
}
